class KlaviyoBackInStock extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
  }

  variantChangeUnsubscriber = undefined;

  connectedCallback() {
    this.onFormSubmit = this.onFormSubmit.bind(this);
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit);
    }

    this.onVariantChange = this.onVariantChange.bind(this);
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.onFormSubmit);
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  removeMessage() {
    if (this.querySelector('[data-klaviyo-success]'))
      this.querySelector('[data-klaviyo-success]').classList.add('hidden');
    if (this.querySelector('[data-klaviyo-error]')) this.querySelector('[data-klaviyo-error]').classList.add('hidden');
  }

  async onFormSubmit(event) {
    console.log('submit');
    event.preventDefault();
    const formData = new FormData(event.target);

    const backInStockSubscription = async () => {
      return fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${formData.get('a')}`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: formData.get('email'),
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  id: `$shopify:::$default:::${formData.get('variant')}`,
                  type: 'catalog-variant',
                },
              },
            },
          },
        }),
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Revision: '2024-07-15',
        },
      });
    };

    const newsletterSubscription = async () => {
      if (formData.get('subscribe_for_newsletter') === 'on') {
        return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${formData.get('a')}`, {
          method: 'POST',
          body: JSON.stringify({
            data: {
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: formData.get('email'),
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    id: formData.get('g'),
                    type: 'list',
                  },
                },
              },
              type: 'subscription',
            },
          }),
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            Revision: '2024-07-15',
          },
        });
      } else {
        // Resolve immediately if newsletter subscription is not needed
        return Promise.resolve({ status: 200 });
      }
    };

    try {
      // Execute both fetch calls concurrently
      const results = await Promise.all([backInStockSubscription(), newsletterSubscription()]);

      // Check if both fetch calls were successful
      if (results.every((res) => res.status === 200 || res.status === 202)) {
        this.querySelector('[data-klaviyo-success]').classList.remove('hidden');
      } else {
        this.querySelector('[data-klaviyo-error]').classList.remove('hidden');
      }
    } catch (err) {
      console.error(err);
      this.querySelector('[data-klaviyo-error]').classList.remove('hidden');
    }
  }

  onVariantChange(event) {
    // check if one of the options in the select has the value of the variant ID
    const variantInput = this.querySelector('[data-klaviyo-product-variant]');
    if (variantInput) {
      variantInput.value = event.data.variant.id;
    }
  }
}

customElements.define('klaviyo-alert', KlaviyoBackInStock);
